import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from "../OneModal/OneModal"
import useVideo from '../../hook/useVideo'
import { useEffect, useState } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { useAppTheme } from '../../Providers/ThemeContext/ThemeContext'
import axios from 'axios'
import { RestartAlt } from '@mui/icons-material'

const Video = ({ open, setOpen, title, eventId, cameraId }) => {
    const { imgRef, loading, dguard, videoLink, tipoCamera, linkBenuvem } = useVideo(eventId, cameraId, setOpen)
    const [erro, setErro] = useState(false)
    const [carregado, setCarregado] = useState(false)

    const [linkVideo, setLinkVideo] = useState(`${videoLink.link}&Df=${Date.now()}`)

    useEffect(() => {
        if (!linkBenuvem) {
            handleImgError()
        }
        setLinkVideo(`${videoLink.link}&Df=${Date.now()}`)
    }, [linkBenuvem, videoLink])

    const { theme } = useAppTheme()

    const handleImgError = (e) => {
        setErro(true)
        setCarregado(false)
    }

    const handleOnLoad = (e) => {
        setErro(false)
        setCarregado(true)
    }

    const handleClose = async (e) => {
        if (dguard) {
            stop_camera_dguard(dguard)
        }
        setTimeout(() => {
            setOpen(e)
        }, 100)
        const imgGravacao = document.getElementById('imgGravacao')
        if (imgGravacao) {
            imgGravacao.src = ''
        }
    }

    const get_pushstreamid_dguard = async (dguard) => {
        const { url, porta, camera, server, receiver, sessaoid } = dguard
        if (!camera || !server || !receiver) { return false }

        const link = `${url}:${porta}/remoterecordings/getpushstreamid.cgi?camera=${camera}&server=${server}&receiver=${receiver}&SessaoId=${sessaoid}`
        let pushstreamid
        try {
            pushstreamid = await axios.get(link)
            return pushstreamid.data
        } catch (error) {
            return false
        }
    }

    const stop_camera_dguard = async (dguard) => {
        let pushstreamid = await get_pushstreamid_dguard(dguard)

        const { url, porta, sessaoid } = dguard
        if (!url || !porta || !sessaoid || !pushstreamid) { return false }

        const link = `${url}:${porta}/remoterecordings/stop.cgi?pushstreamid=${pushstreamid}&SessaoId=${sessaoid}`
        let stop
        try {
            stop = await axios.get(link)
            return (stop.data == 200 && stop.data && stop.data == 'OK')
        } catch (error) {
            return false
        }
    }

    const resetVideo = () => {
        setLinkVideo(`${videoLink.link}&Df=${Date.now()}`)
    }

    const Video = () => {
        return (
            <>
                {
                    tipoCamera == 3
                        ? !linkBenuvem
                            ? <div>Gravação não encontrada</div>
                            : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                                {linkBenuvem.map((link, index) =>
                                    <video
                                        key={index}
                                        width={"35%"}
                                        height={"50%"}
                                        style={{ margin: '10px' }}
                                        onLoadedData={handleOnLoad}
                                        controls
                                    >
                                        <source key={index} src={link.url} type="video/mp4" />
                                        Seu navegador não suporta mp4
                                    </video>
                                )}
                            </div>
                        : <img style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto' }}
                            ref={imgRef} id='imgGravacao' src={tipoCamera == 1 ? linkVideo : imgRef.current?.src} onError={handleImgError} onLoad={handleOnLoad} />
                }

                {carregado && tipoCamera == 1 &&
                <RestartAlt
                    titleAccess='Reiniciar o vídeo'
                    onClick={resetVideo}
                    sx={{
                        position: 'absolute',
                        bottom: '5%',
                        color: 'white',
                        width: '35px',
                        height: '35px',
                        cursor: 'pointer'
                    }} />
                }

                {(imgRef.current?.currentSrc && erro) &&
                    <span>O servidor de imagem não respondeu. <a target="_blank" href={imgRef.current?.currentSrc} rel="noreferrer" >Clique aqui</a> para tentar abrir a gravação direto no navegeador</span>
                }

                {(!erro && !carregado) &&
                    <Box sx={{ display: 'flex', width: '390px', height: '260px', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress size={90} sx={{ color: theme.palette.one_primary.main }} />
                    </Box>
                }
            </>

        )
    }
    return (
        <>
            <OneModal
                open={open}
                setOpen={handleClose}
                titleText={title}
                fullWidth={true}
                loading={loading}
            >
                <Grid container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Video />
                </Grid>
            </OneModal>
        </>
    )
}

export default Video
